module.exports = __webpack_public_path__ + "img/logo.8d35f1f0.png";